


(() => {
  'use strict';

  if (window.__tbgPageLoaded) return;
  window.__tbgPageLoaded = true;

  const ROOT_SELECTOR = '[data-tbg-product-root]';

  const formatMoney = (cents, format = '${{amount}}') => {
    const value = Number(cents || 0);
    const amount = (value / 100).toFixed(2);
    const amountNoDecimals = Math.round(value / 100).toString();
    const amountWithComma = amount.replace('.', ',');
    const amountNoDecimalsWithComma = amountNoDecimals.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

    return format
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, amountNoDecimalsWithComma)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amountWithComma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals)
      .replace(/\{\{\s*amount\s*\}\}/g, amount);
  };

  const getShopRoot = () => window.Shopify?.routes?.root || '/';

  const getCartAddUrl = () =>
    window.routes?.cart_add_url || `${getShopRoot()}cart/add.js`;

  const getCartUrl = () =>
    window.routes?.cart_url || `${getShopRoot()}cart`;

  class TbgProductRoot {
    constructor(root, index) {
      this.root = root;
      this.instanceId = `${Date.now()}-${index}-${Math.random().toString(16).slice(2)}`;
      this.data = this.readData();

      if (!this.data || !Array.isArray(this.data.variants) || !this.data.variants.length) return;

      const initialId = Number(this.root.querySelector('[data-tbg-variant-input]')?.value);

      this.variant =
        this.data.variants.find((item) => Number(item.id) === initialId) ||
        this.data.variants.find((item) => item.available) ||
        this.data.variants[0];

      this.purchaseMode =
        this.root.querySelector('[data-tbg-purchase-mode].is-active')?.dataset.tbgPurchaseMode ||
        'one-time';

      this.bind();
      this.render(false);
    }

    readData() {
      const node = this.root.querySelector('[data-tbg-product-json]');
      if (!node) return null;

      try {
        return JSON.parse(node.textContent);
      } catch (error) {
        console.warn('TBG: Product JSON could not be parsed.', error);
        return null;
      }
    }

    bind() {
      this.root.querySelectorAll('[data-tbg-option-value]').forEach((button) => {
        button.addEventListener('click', () => {
          const position = Number(button.dataset.optionPosition || 1);
          this.selectOption(position, button.dataset.tbgOptionValue);
        });
      });

      this.root.querySelectorAll('[data-tbg-option-select]').forEach((select) => {
        select.addEventListener('change', () => {
          const position = Number(select.dataset.optionPosition || 1);
          this.selectOption(position, select.value);
        });
      });

      this.root.querySelectorAll('[data-tbg-purchase-mode]').forEach((button) => {
        button.addEventListener('click', () => {
          this.purchaseMode = button.dataset.tbgPurchaseMode || 'one-time';
          this.render();
        });
      });
this.root.querySelectorAll('[data-tbg-selling-plan-select]').forEach((select) => {

  select.addEventListener('change', () => {

    this.render(false);

  });

});

      this.root.querySelectorAll('[data-tbg-gallery-thumb]').forEach((button) => {
        button.addEventListener('click', () => this.changeGallery(button));
      });

      /*
       * The custom TBG forms are plain Shopify forms, not Dawn's
       * <product-form> web component. Handle their submission here so the
       * selling plan is sent and Dawn's cart drawer can update and open.
       */
    //   this.root.querySelectorAll('form.tbg-product-form').forEach((form) => {
    //     form.addEventListener('submit', (event) => this.submitForm(event, form));
    //   });

      document.addEventListener('tbg:variant-change', (event) => {
        const detail = event.detail || {};

        if (
          detail.source === this.instanceId ||
          Number(detail.productId) !== Number(this.data.id)
        ) {
          return;
        }

        const nextVariant = this.data.variants.find(
          (item) => Number(item.id) === Number(detail.variantId)
        );

        if (!nextVariant) return;

        this.variant = nextVariant;
        if (detail.purchaseMode) this.purchaseMode = detail.purchaseMode;
        this.render(false);
      });
    }

    selectOption(position, value) {
      const desiredOptions = [...this.variant.options];
      desiredOptions[position - 1] = value;

      let nextVariant = this.data.variants.find((variant) =>
        variant.options.every((option, index) => option === desiredOptions[index])
      );

      if (!nextVariant) {
        nextVariant = this.data.variants.find(
          (variant) => variant.options[position - 1] === value
        );
      }

      if (!nextVariant) return;

      this.variant = nextVariant;
      this.render();
    }

    getValidAllocations() {
      return Array.isArray(this.variant.selling_plan_allocations)
        ? this.variant.selling_plan_allocations
        : [];
    }

    syncSellingPlanSelect() {
      const allocations = this.getValidAllocations();
      const validPlanIds = new Set(
        allocations.map((allocation) => String(allocation.selling_plan_id))
      );

      this.root.querySelectorAll('[data-tbg-selling-plan-select]').forEach((select) => {
        Array.from(select.options).forEach((option) => {
          option.disabled = !validPlanIds.has(String(option.value));
        });

        if (!validPlanIds.has(String(select.value))) {
          const firstValidOption = Array.from(select.options).find((option) => !option.disabled);
          if (firstValidOption) select.value = firstValidOption.value;
        }
      });
    }

    getPlanId() {
      if (this.purchaseMode !== 'subscription') return null;

      const allocations = this.getValidAllocations();
      if (!allocations.length) return null;

      const select = this.root.querySelector('[data-tbg-selling-plan-select]');
      const requestedPlanId = Number(select?.value || 0);

      const requestedAllocation = allocations.find(
        (allocation) => Number(allocation.selling_plan_id) === requestedPlanId
      );

      if (requestedAllocation) return Number(requestedAllocation.selling_plan_id);

      return Number(allocations[0].selling_plan_id) || null;
    }

    getAllocation(planId = this.getPlanId()) {
      if (!planId) return null;

      return (
        this.getValidAllocations().find(
          (allocation) => Number(allocation.selling_plan_id) === Number(planId)
        ) || null
      );
    }

    getDisplayedPrice() {
      const allocation = this.getAllocation();
      return allocation?.price ?? this.variant.price;
    }

    syncSellingPlanInput() {
  const form = this.root.querySelector('form');

  if (!form) return;


  const sellingPlanId =
    this.purchaseMode === 'subscription'
      ? this.getPlanId()
      : '';


  /*
    Update ALL selling_plan inputs inside form
    including Seal's input
  */
  form.querySelectorAll(
    'input[name="selling_plan"]'
  ).forEach((input) => {

    input.value = sellingPlanId || '';

  });


  /*
    If no input exists, create one
  */
  if (
    sellingPlanId &&
    !form.querySelector(
      'input[name="selling_plan"]'
    )
  ) {

    const input =
      document.createElement('input');

    input.type = 'hidden';
    input.name = 'selling_plan';
    input.value = sellingPlanId;

    form.appendChild(input);

  }
}

    render(emit = true) {
      this.syncSellingPlanSelect();

      const planId = this.getPlanId();
      const allocation = this.getAllocation(planId);
      const isSubscription = this.purchaseMode === 'subscription' && Boolean(planId);
      const price = isSubscription ? allocation?.price ?? this.variant.price : this.variant.price;

      this.root.querySelectorAll('[data-tbg-option-value]').forEach((button) => {
        const position = Number(button.dataset.optionPosition || 1);
        const active = this.variant.options[position - 1] === button.dataset.tbgOptionValue;

        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      this.root.querySelectorAll('[data-tbg-option-select]').forEach((select) => {
        const position = Number(select.dataset.optionPosition || 1);
        select.value = this.variant.options[position - 1] || '';
      });

      this.root.querySelectorAll('[data-tbg-purchase-mode]').forEach((button) => {
        const active = button.dataset.tbgPurchaseMode === this.purchaseMode;

        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      this.root.querySelectorAll('[data-tbg-selling-plan-wrap]').forEach((wrap) => {
        wrap.hidden = this.purchaseMode !== 'subscription';
      });

      this.root.querySelectorAll('[data-tbg-variant-input]').forEach((input) => {
        input.value = this.variant.id;
        input.disabled = false;
      });

     this.root.querySelectorAll('[data-tbg-selling-plan-input]').forEach((input) => {

  if (isSubscription && planId) {

    input.value = String(planId);
    input.disabled = false;

  } else {

    input.value = '';
    input.disabled = true;

  }

});

      this.syncSellingPlanInput();

      const formattedPrice = formatMoney(price, this.data.money_format);
      const regularFormattedPrice = formatMoney(this.variant.price, this.data.money_format);

      this.root
        .querySelectorAll('[data-tbg-current-price], [data-tbg-button-price]')
        .forEach((node) => {
          node.textContent = formattedPrice;
        });

      this.root.querySelectorAll('[data-tbg-one-time-price]').forEach((node) => {
        node.textContent = regularFormattedPrice;
      });

      const displayedSubscriptionAllocation =
        allocation || this.getValidAllocations()[0] || null;

      this.root.querySelectorAll('[data-tbg-subscription-price]').forEach((node) => {
        node.textContent = formatMoney(
          displayedSubscriptionAllocation?.price ?? this.variant.price,
          this.data.money_format
        );
      });

      this.root.querySelectorAll('[data-tbg-subscription-saving]').forEach((node) => {
        const subscriptionPrice = displayedSubscriptionAllocation?.price;
        const saving =
          subscriptionPrice != null && this.variant.price > 0
            ? Math.max(
                0,
                Math.round((1 - subscriptionPrice / this.variant.price) * 100)
              )
            : 0;

        node.textContent = saving ? `${saving}%` : '';
      });

      const subscriptionUnavailable =
        this.purchaseMode === 'subscription' && !this.getValidAllocations().length;
      const available = Boolean(this.variant.available) && !subscriptionUnavailable;

      this.root.querySelectorAll('[data-tbg-add-button]').forEach((button) => {
        button.disabled = !available;
      });

      this.root.querySelectorAll('[data-tbg-add-label]').forEach((node) => {
        if (!this.variant.available) {
          node.textContent = 'Sold out';
        } else if (subscriptionUnavailable) {
          node.textContent = 'Subscription unavailable';
        } else {
          node.textContent = node.dataset.defaultLabel || 'Add to cart';
        }
      });

      if (this.variant.featured_image) {
        this.root
          .querySelectorAll('[data-tbg-main-image], [data-tbg-main-image-wrapper] img')
          .forEach((image) => {
            image.src = this.variant.featured_image;
          });
      }

      if (emit) {
        document.dispatchEvent(
          new CustomEvent('tbg:variant-change', {
            detail: {
              source: this.instanceId,
              productId: this.data.id,
              variantId: this.variant.id,
              purchaseMode: this.purchaseMode,
              sellingPlanId: planId,
            },
          })
        );
      }
    }

    setFormLoading(form, loading) {
      const button = form.querySelector('[data-tbg-add-button]');
      const label = form.querySelector('[data-tbg-add-label]');

      if (!button) return;

      button.classList.toggle('is-loading', loading);
      button.setAttribute('aria-busy', loading ? 'true' : 'false');

      if (loading) {
        button.setAttribute('aria-disabled', 'true');
        if (label) label.textContent = 'Adding…';
      } else {
        button.removeAttribute('aria-disabled');
        this.render(false);
      }
    }

    showFormError(form, message = '') {
      let errorNode = form.querySelector('[data-tbg-form-error]');

      if (!errorNode && message) {
        errorNode = document.createElement('p');
        errorNode.className = 'tbg-product-form__error';
        errorNode.dataset.tbgFormError = '';
        errorNode.setAttribute('role', 'alert');
        form.appendChild(errorNode);
      }

      if (!errorNode) return;

      errorNode.textContent = message;
      errorNode.hidden = !message;
    }
// async submitForm(event, form) {
//   event.preventDefault();

//   const button = form.querySelector('[data-tbg-add-button]');

//   if (
//     !button ||
//     button.disabled ||
//     button.getAttribute('aria-disabled') === 'true'
//   ) {
//     return;
//   }

//   const planId = this.getPlanId();

//   if (this.purchaseMode === 'subscription' && !planId) {
//     this.showFormError(
//       form,
//       'A subscription plan is not available for the selected variant.'
//     );
//     return;
//   }


//   this.showFormError(form, '');
//   this.setFormLoading(form, true);


//   const formData = new FormData(form);

//   formData.set(
//     'id',
//     String(this.variant.id)
//   );

//   formData.set(
//     'quantity',
//     String(formData.get('quantity') || 1)
//   );


//   if (this.purchaseMode === 'subscription') {

//     formData.set(
//       'selling_plan',
//       String(planId)
//     );

//   } else {

//     formData.delete('selling_plan');

//   }


//   /*
//    * Get Dawn cart sections
//    */
//   const cartDrawer =
//     document.querySelector('cart-drawer');


//   if (
//     cartDrawer &&
//     typeof cartDrawer.getSectionsToRender === 'function'
//   ) {

//     const sections =
//       cartDrawer
//         .getSectionsToRender()
//         .map(section => section.id)
//         .filter(Boolean);


//     formData.set(
//       'sections',
//       sections.join(',')
//     );


//     formData.set(
//       'sections_url',
//       window.location.pathname
//     );

//   }


//   const config =
//     typeof window.fetchConfig === 'function'
//       ? window.fetchConfig('javascript')
//       : {
//           method: 'POST',
//           headers: {
//             Accept: 'application/json'
//           }
//         };


//   config.headers = config.headers || {};

//   config.headers.Accept =
//     'application/json';

//   config.headers['X-Requested-With'] =
//     'XMLHttpRequest';

//   delete config.headers['Content-Type'];

//   config.body = formData;


//   try {

//     const response =
//       await fetch(
//         getCartAddUrl(),
//         config
//       );


//     const result =
//       await response.json();


//     if (
//       !response.ok ||
//       result.status
//     ) {

//       throw new Error(
//         result.description ||
//         result.message ||
//         'Unable to add product to cart.'
//       );

//     }


//     console.log(
//       'TBG CART RESULT',
//       result
//     );


//     document.dispatchEvent(
//       new CustomEvent(
//         'tbg:cart-added',
//         {
//           detail: {
//             productId: this.data.id,
//             variantId: this.variant.id,
//             purchaseMode: this.purchaseMode,
//             sellingPlanId:
//               this.purchaseMode === 'subscription'
//                 ? planId
//                 : null,
//             response: result
//           }
//         }
//       )
//     );


//     /*
//      * Use Dawn native cart rendering
//      */
//     const currentDrawer =
//       document.querySelector('cart-drawer');


//     if (
//       currentDrawer &&
//       typeof currentDrawer.renderContents === 'function'
//     ) {

//       currentDrawer.renderContents(result);

//     } else {

//       window.location.href =
//         getCartUrl();

//     }


//   } catch(error) {

//     console.error(
//       'TBG add-to-cart error:',
//       error
//     );


//     this.showFormError(
//       form,
//       error.message ||
//       'Something went wrong. Please try again.'
//     );


//   } finally {

//     this.setFormLoading(
//       form,
//       false
//     );

//   }
// }

    changeGallery(button) {
      const image = this.root.querySelector(
        '[data-tbg-main-image], [data-tbg-main-image-wrapper] img'
      );

      if (!image) return;

      if (button.dataset.imageSrc) image.src = button.dataset.imageSrc;
      if (button.dataset.imageAlt) image.alt = button.dataset.imageAlt;

      this.root.querySelectorAll('[data-tbg-gallery-thumb]').forEach((item) => {
        item.classList.toggle('is-active', item === button);
      });
    }
  }

  const initAccordions = (scope = document) => {
    scope.querySelectorAll('[data-tbg-accordion-button]').forEach((button) => {
      if (button.dataset.tbgReady === 'true') return;

      button.dataset.tbgReady = 'true';
      button.addEventListener('click', () => {
        const expanded = button.getAttribute('aria-expanded') === 'true';
        const panel = document.getElementById(button.getAttribute('aria-controls'));

        button.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        if (panel) panel.hidden = expanded;
      });
    });
  };

  const initProducts = (scope = document) => {
    scope.querySelectorAll(ROOT_SELECTOR).forEach((root, index) => {
      if (root.dataset.tbgInitialized === 'true') return;

      root.dataset.tbgInitialized = 'true';
      new TbgProductRoot(root, index);
    });
  };

  /* =========================================================
     TBG INLINE VIDEO CARDS
     ========================================================= */

  const VIDEO_CARD_SELECTOR = '[data-tbg-video-card]';
  const VIDEO_SELECTOR = `${VIDEO_CARD_SELECTOR} video`;

  const updateVideoCardState = (card, isPlaying) => {
    if (!card) return;

    const videoTitle = card.dataset.videoTitle || 'video';
    card.classList.toggle('is-playing', isPlaying);
    card.setAttribute('aria-pressed', isPlaying ? 'true' : 'false');
    card.setAttribute('aria-label', `${isPlaying ? 'Pause' : 'Play'} ${videoTitle}`);
  };

  const pauseOtherVideos = (activeVideo = null) => {
    document.querySelectorAll(VIDEO_SELECTOR).forEach((video) => {
      if (video !== activeVideo && !video.paused) video.pause();
    });
  };

  const toggleVideo = async (card) => {
    const video = card?.querySelector('video');
    if (!video) return;

    if (video.paused || video.ended) {
      pauseOtherVideos(video);

      try {
        await video.play();
      } catch (error) {
        console.warn('TBG video could not be played:', error);
      }
    } else {
      video.pause();
    }
  };

  const initVideoEvents = () => {
    if (window.__tbgVideoEventsLoaded) return;
    window.__tbgVideoEventsLoaded = true;

    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;

      const card = event.target.closest(VIDEO_CARD_SELECTOR);
      if (card) toggleVideo(card);
    });

    document.addEventListener('keydown', (event) => {
      if (!(event.target instanceof Element)) return;

      const card = event.target.closest(VIDEO_CARD_SELECTOR);
      if (!card || (event.key !== 'Enter' && event.key !== ' ')) return;

      event.preventDefault();
      toggleVideo(card);
    });

    document.addEventListener(
      'play',
      (event) => {
        if (!(event.target instanceof HTMLVideoElement)) return;

        const card = event.target.closest(VIDEO_CARD_SELECTOR);
        if (!card) return;

        pauseOtherVideos(event.target);
        card.classList.add('has-started');
        updateVideoCardState(card, true);
      },
      true
    );

    document.addEventListener(
      'pause',
      (event) => {
        if (!(event.target instanceof HTMLVideoElement)) return;

        const card = event.target.closest(VIDEO_CARD_SELECTOR);
        if (card) updateVideoCardState(card, false);
      },
      true
    );

    document.addEventListener(
      'ended',
      (event) => {
        if (!(event.target instanceof HTMLVideoElement)) return;

        const card = event.target.closest(VIDEO_CARD_SELECTOR);
        if (!card) return;

        card.classList.remove('has-started');
        updateVideoCardState(card, false);
        event.target.currentTime = 0;
      },
      true
    );

    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('video').forEach((video) => video.pause());
    });
  };

  const init = (scope = document) => {
    initAccordions(scope);
    initProducts(scope);
    initVideoEvents();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
